import styled, { css } from 'styled-components';
import { smLight, smRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';

import { HudIcon } from '../Icons/HudIcons';

export const Container = styled.div<{
  $hasContent?: boolean;
  $inline?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;

  border-radius: 8px;
  ${(props) =>
    props.theme.name === 'dark' &&
    css`
      box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
    `}

  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};

  &:hover,
  &:focus-within {
    background: ${themeColor('buttonBackgroundHover')};
  }
  ${({ $hasContent }) =>
    $hasContent && `background: ${themeColor('buttonBackgroundHover')};`}

  ${({ $inline }) =>
    $inline
      ? css`
          width: 227px;
        `
      : css`
          width: 100%;
        `}
`;

export const Input = styled.input`
  ${smRegular}

  background-color: transparent;
  border: none;
  outline: none;
  color: ${themeColor('textPrimary')};
  width: 100%;

  &::placeholder {
    ${smLight}
    color: ${themeColor('textTertiary')};
  }
`;

export const Icon = styled(HudIcon)`
  color: ${themeColor('textTertiary')};
`;
